/**
 * @fileoverview Page Not Found Searcher Controller Module.
 * Manages the search functionality on the 'Page Not Found' (404) page.
 * This includes initializing event listeners for the search input and handling form submissions.
 */

import {elementExists, getFullIndexName} from "../Utils";
const searchPageIndex = getFullIndexName('action');
const PageNotFoundSearcherController = {
    searchInputSelector: '.page-not-found-search-input-js',
    formId: 'search-form',

    /**
     * Initializes the PageNotFoundSearcherController.
     * Sets up event listeners if the search input element exists.
     */
    init() {
        if (! elementExists(this.searchInputSelector)) return;
        this.setListeners();
    },

    /**
     * Sets up event listeners for the search form.
     */
    setListeners() {
        document.getElementById(this.formId).addEventListener('submit', (ev) => this.inputSubmittedHandler(ev));
    },

    /**
     * Handles the search form submission.
     * Redirects to the search page with the query parameter from the input field.
     * @param {Event} ev - The submit event object.
     */
    inputSubmittedHandler(ev) {
        ev.preventDefault();
        const input = document.querySelector(this.searchInputSelector);
        const query = input.value.trim();
        // window.location.href = `/search-page?${searchPageIndex}%5Bquery%5D=${encodeURIComponent(query)}`;
        window.location.href = `/search-page${query ? `?query=${encodeURIComponent(query)}` : ''}`
    }
};

export default PageNotFoundSearcherController;
